import { Button, IconModal } from '@airtm/airtm-ui';
import { useTranslation, Trans } from 'react-i18next';

function EnterpriseLoginErrorModal({
  show,
  onClose,
}: {
  readonly show: boolean;
  readonly onClose: () => void;
}) {
  const { t } = useTranslation(['LOGIN', 'STATIC']);

  return (
    <IconModal show={show} modalClose={onClose}>
      <IconModal.Body>
        <h3 className="mb-0 text--uppercase">{t('LOGIN:ENTERPRISE_ACCOUNT_MODAL_TITLE')}</h3>
        <div className="text--headings u-mt-3">
          <Trans
            components={[
              <a
                key="enterprise-link"
                href={t('LOGIN:ENTERPRISE_ACCOUNT_MODAL_LINK')}
                target="_blank"
                rel="noopener noreferrer"
                className="text--headings text--underline"
              >
                enterprise.airtm.com
              </a>,
            ]}
            i18nKey="LOGIN:ENTERPRISE_ACCOUNT_MODAL_DESCRIPTION"
          />
        </div>
      </IconModal.Body>
      <IconModal.Actions>
        <Button
          variant="primary"
          component="a"
          target="_blank"
          rel="noopener noreferrer"
          href={t('LOGIN:ENTERPRISE_ACCOUNT_MODAL_LINK')}
          block
        >
          {t('LOGIN:ENTERPRISE_ACCOUNT_MODAL_CTA')}
        </Button>
      </IconModal.Actions>
    </IconModal>
  );
}

export default EnterpriseLoginErrorModal;
